const translations = {
  "en": {
    "Action": "Action",
    "Cost": "Cost",
    "Date & Time": "Date & Time",
    "Delete": "Delete",
    "Delete Transaction?": "Delete Transaction?",
    "Edit": "Edit",
    "Edit Transaction": "Edit Transaction",
    "Fees": "Fees",
    "Price": "Price",
    "Quantity": "Shares",
    "Type": "Type"
  },
  "zh-tw": {
    "Action": "操作",
    "Cost": "成本",
    "Date & Time": "日期與時間",
    "Delete": "刪除",
    "Delete Transaction?": "刪除交易？",
    "Edit": "編輯",
    "Edit Transaction": "編輯交易",
    "Fees": "手續費",
    "Price": "價格",
    "Quantity": "股數",
    "Type": "類型"
  }
};

export default translations;
